// Display formatting helpers — keep all locale-aware formatting in one place.

const compact = new Intl.NumberFormat(undefined, { notation: "compact", maximumFractionDigits: 1 });
const standard = new Intl.NumberFormat();
const pct = new Intl.NumberFormat(undefined, { style: "percent", maximumFractionDigits: 1 });

export function fmtCount(n: number): string {
  return n >= 10_000 ? compact.format(n) : standard.format(n);
}

export function fmtNumber(n: number): string { return standard.format(n); }
export function fmtPct(n: number): string { return pct.format(n); }

const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
const TIME_UNITS: Array<[Intl.RelativeTimeFormatUnit, number]> = [
  ["year", 60 * 60 * 24 * 365],
  ["month", 60 * 60 * 24 * 30],
  ["day", 60 * 60 * 24],
  ["hour", 60 * 60],
  ["minute", 60],
  ["second", 1],
];

export function fmtRelative(iso: string | Date | undefined): string {
  if (!iso) return "—";
  const date = typeof iso === "string" ? new Date(iso) : iso;
  const delta = (date.getTime() - Date.now()) / 1000;
  for (const [unit, sec] of TIME_UNITS) {
    if (Math.abs(delta) >= sec || unit === "second") return rtf.format(Math.round(delta / sec), unit);
  }
  return "—";
}

export function fmtDate(iso: string | Date | undefined): string {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

export function fmtDateTime(iso: string | Date | undefined): string {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

export function initials(name: string): string {
  return name.split(/\s+/).map(p => p[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
}

export function truncate(s: string, n = 80): string {
  return s.length > n ? s.slice(0, n - 1) + "…" : s;
}
